let focusElement = $('.card-item__focus');
let card = $('[data-member-card]');
let cardNumber = $('[for="cardNumber"]');

let cardHolderFirstNameInput = $('#cardHolderFirstName');
let cardHolderLastNameInput = $('#cardHolderLastName');
let cardHolder = $('[data-card-holder]');

let dayInput = $('#dayInput');
let cardDay = $('[data-card-day]');
let monthInput = $('#monthInput');
let cardMonth = $('[data-card-month]');
let yearInput = $('#yearInput');
let cardYear = $('[data-card-year]');
let countryInput = $('[data-country-select]');
let countryList = $('[data-country-list]');
let cwInput = $('#cwInput');
let cwMobile = $('[data-mobile-number]');

var cardNumberDigit = Math.floor(10000000 + Math.random() * 90000000);
let cardNumberArr = Array.from(cardNumberDigit.toString().split(''));
$.each(cardNumberArr, function(index, digit) {
    if (index < 4) {
        cardNumber.find('span[data-number-index="'+ (index + 1) +'"] .card-item__numberItem').html(digit);
    } else {
        cardNumber.find('span[data-number-index="'+ (index + 9) +'"] .card-item__numberItem').html(digit);
    }
});

let date = new Date();
date.setDate(date.getDate() + 14); 
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();
cardDay.find('span').html(day < 10 ? '0'+ day : day);
cardMonth.find('span').html(month < 10 ? '0'+ month : month);
cardYear.find('span').html(year);
        
cardHolderFirstNameInput.bind("keyup paste", function (e) {
    if (this.value || cardHolderLastNameInput.val() != '') {
        cardHolder.html(this.value + ' ' + cardHolderLastNameInput.val());
    } else {
        cardHolder.html('FULL NAME');
    }
});

cardHolderLastNameInput.bind("keyup paste", function (e) {
    if (this.value || cardHolderFirstNameInput.val() != '') {
        cardHolder.html(cardHolderFirstNameInput.val() + ' ' + this.value);
    } else {
        cardHolder.html('FULL NAME');
    }
});

if (cardHolder.data('card-holder')) {
    cardHolder.html(cardHolder.data('card-holder'));
}

let cardHolderWrap = $('[for="cardName"]');
let inputToBlur = [
    {
        selector: cardHolderFirstNameInput,
        focusElement: focusElement,
    },
    {
        selector: cardHolderLastNameInput,
        focusElement: focusElement,
    }
];

inputToBlur.forEach(function (element) {
    blurInput(element.selector, element.focusElement);
});

function blurInput(selector, focusElement) {
    selector.on('focusin', function (e) {
        let targetRef = e.target.dataset.ref;
        let target = document.querySelector('[ref="'+ targetRef +'"]');
        focusElementStyle = {
            width: `${target.offsetWidth}px`,
            height: `${target.offsetHeight}px`,
            transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
        }
        focusElement.addClass('-active');
        focusElement.css(focusElementStyle);
    });

    selector.on('focusout', function (e) {
        focusElement.removeClass('-active');
        focusElement.removeAttr('style');
    });
}

countryInput.on("click", function (e) {
    card.addClass('-active');
});

countryList.on('click', 'li', function() {
    cwMobile.html('(' + this.dataset.code + ') ' + cwInput.val());
});

cwInput.bind("keyup paste", function (e) {
    if (this.value) {
        cwMobile.html('(' + $('.rise-select-dropdown.country-with-code .selected > span:first-child').html() + ') ' + this.value);
    } else {
        cwMobile.html('');
    }
});

cwInput.on("click", function (e) {
    card.addClass('-active');
});

$(document).on('click', function (e) { 
    if (!$(e.target).is('#cwInput') && !$(e.target).is('[data-country-select]') && $(e.target).closest('[data-country-select]').length == 0 && !$(e.target).is('[data-country-list]') && $(e.target).closest('[data-country-list]').length == 0) {
        card.removeClass('-active');
    }
});

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

var email = getUrlParameter('email');
if (email) {
    $('input[name="contact[email]"]').val(email);
}
var firstname = getUrlParameter('firstname');
if (firstname) {
    $('input[name="contact[first_name]"]').val(firstname);
}
var lastname = getUrlParameter('lastname');
if (lastname) {
    $('input[name="contact[last_name]"]').val(lastname);
}
if (firstname && lastname) {
    $('[data-card-holder]').html(firstname + ' ' + lastname);
}

var gender = getUrlParameter('gender');
if (gender) {
    $('.rise-select-dropdown.gender .selected span:first-child').html(gender);
    $('input[name="contact[gender]"]').val(gender);
}

var birthday = getUrlParameter('birthday');
if (birthday) {
    let d = new Date(birthday);
    let day = d.getDate();
    let month = d.getMonth() + 1;
    month = month < 10 ? '0'+ month : month;
    let year = d.getFullYear();
    var monthArr = {
        '01': 'JAN',
        '02': 'FEB',
        '03': 'MAR',
        '04': 'APRIL',
        '05': 'MAY',
        '06': 'JUNE',
        '07': 'JULY',
        '08': 'AUG',
        '09': 'SEPT',
        '10': 'OCT',
        '11': 'NOV',
        '12': 'DEC'
    };
    
    $('.rise-select-dropdown.days .selected span:first-child').html(day);
    $('input[name="contact[birth_day]"]').val(day);

    $('.rise-select-dropdown.months .selected span:first-child').html(monthArr[month]);
    $('input[name="contact[birth_month]"]').val(month);

    $('.rise-select-dropdown.year .selected span:first-child').html(year);
    $('input[name="contact[birth_year]"]').val(year);
}




